import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../shared/shared.module';
import { CollaboPortalChangePasswordSentComponent } from './collabo-portal-change-password-sent/collabo-portal-change-password-sent.component';
import { CollaboPortalDxsalesChangePasswordSentComponent } from './collabo-portal-dxsales-change-password-sent/collabo-portal-dxsales-change-password-sent.component';
import { CollaboPortalDxsalesForgotPasswordComponent } from './collabo-portal-dxsales-forgot-password/collabo-portal-dxsales-forgot-password.component';
import { CollaboPortalDxsalesLoginComponent } from './collabo-portal-dxsales-login/collabo-portal-dxsales-login.component';
import { CollaboPortalDxSalesUpdatedPasswordComponent } from './collabo-portal-dxsales-updated-password/collabo-portal-dxsales-updated-password.component';
import { CollaboPortalInputComponent } from './collabo-portal-input/collabo-portal-input.component';
import { CollaboPortalKanriLoginComponent } from './collabo-portal-kanri-login/collabo-portal-kanri-login.component';
import { CollaboPortalLoginComponent } from './collabo-portal-login/collabo-portal-login.component';
import { CollaboPortalPasswordInputComponent } from './collabo-portal-password-input/collabo-portal-password-input.component';
import { CollaboPortalRegisterResendComponent } from './collabo-portal-register-resend/collabo-portal-register-resend.component';
import { CollaboPortalRegisterSendComponent } from './collabo-portal-register-send/collabo-portal-register-send.component';
import { CollaboPortalResetPasswordComponent } from './collabo-portal-reset-password/collabo-portal-reset-password.component';
import { CollaboPortalUnblockComponent } from './collabo-portal-unblock/collabo-portal-unblock.component';
import { CollaboPortalUpdatedPasswordComponent } from './collabo-portal-updated-password/collabo-portal-updated-password.component';
import { CollaboPortalComponent } from './collabo-portal/collabo-portal.component';
import { ConnectDoctorsIdRegisterSendComponent } from './connect-doctors-id/connect-doctors-id-register-send/connect-doctors-id-register-send.component';
import { ConnectDoctorsIdComponent } from './connect-doctors-id/connect-doctors-id.component';
import { RequiredLabelComponent } from './required-label/required-label.component';

@NgModule({
  declarations: [
    CollaboPortalLoginComponent,
    CollaboPortalComponent,
    CollaboPortalRegisterSendComponent,
    CollaboPortalRegisterResendComponent,
    CollaboPortalResetPasswordComponent,
    CollaboPortalDxsalesForgotPasswordComponent,
    CollaboPortalUnblockComponent,
    CollaboPortalInputComponent,
    CollaboPortalChangePasswordSentComponent,
    CollaboPortalDxsalesChangePasswordSentComponent,
    CollaboPortalPasswordInputComponent,
    CollaboPortalDxsalesLoginComponent,
    CollaboPortalKanriLoginComponent,
    ConnectDoctorsIdComponent,
    ConnectDoctorsIdRegisterSendComponent,
    RequiredLabelComponent,
    CollaboPortalUpdatedPasswordComponent,
    CollaboPortalDxSalesUpdatedPasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    AppRoutingModule,
    SharedModule,
  ],
  exports: [
    CollaboPortalLoginComponent,
    CollaboPortalComponent,
    CollaboPortalRegisterSendComponent,
    CollaboPortalRegisterResendComponent,
    CollaboPortalResetPasswordComponent,
    CollaboPortalDxsalesForgotPasswordComponent,
    CollaboPortalUnblockComponent,
    CollaboPortalInputComponent,
    CollaboPortalChangePasswordSentComponent,
    CollaboPortalDxsalesChangePasswordSentComponent,
  ],
})
export class CollaboPortalModule { }
